
import { Vue, Prop, Component } from 'vue-property-decorator';
import { eInputType } from '@/interface/exchange-code';

@Component
export default class ExchangePop extends Vue {
  @Prop() text!: any;
  @Prop() titleValue!: string;
  @Prop() fillText1!: string;

  eInputType: any = eInputType;
  // getplaceholder(value: string) {
  //   console.log(this.fillText1 + '.........' + value + '---------' + this.isShow);
  //   return value === '1' ? '请输入跳转连接' : '请输入云更新游戏资源gid';
  // }
  mounted() {
    // console.log('dee');
    // console.log(this.images);
    // console.log(this.fillText1);
  }
}
